import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import pt from "./locales/pt.json";
import it from "./locales/it.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import zh from "./locales/zh.json";
import ar from "./locales/ar.json";
import hi from "./locales/hi.json";
import ru from "./locales/ru.json";
import no from "./locales/no.json";
import tl from "./locales/tl.json";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", flag: "GB", dir: "ltr" },
  { code: "es", label: "Español", flag: "ES", dir: "ltr" },
  { code: "fr", label: "Français", flag: "FR", dir: "ltr" },
  { code: "de", label: "Deutsch", flag: "DE", dir: "ltr" },
  { code: "pt", label: "Português", flag: "BR", dir: "ltr" },
  { code: "it", label: "Italiano", flag: "IT", dir: "ltr" },
  { code: "ja", label: "日本語", flag: "JP", dir: "ltr" },
  { code: "ko", label: "한국어", flag: "KR", dir: "ltr" },
  { code: "zh", label: "中文", flag: "CN", dir: "ltr" },
  { code: "ar", label: "العربية", flag: "SA", dir: "rtl" },
  { code: "hi", label: "हिन्दी", flag: "IN", dir: "ltr" },
  { code: "ru", label: "Русский", flag: "RU", dir: "ltr" },
  { code: "no", label: "Norsk", flag: "NO", dir: "ltr" },
  { code: "tl", label: "Tagalog", flag: "PH", dir: "ltr" },
] as const;

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
  pt: { translation: pt },
  it: { translation: it },
  ja: { translation: ja },
  ko: { translation: ko },
  zh: { translation: zh },
  ar: { translation: ar },
  hi: { translation: hi },
  ru: { translation: ru },
  no: { translation: no },
  tl: { translation: tl },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18n_language",
      caches: ["localStorage"],
    },
  });

export default i18n;
